module.exports = __webpack_public_path__ + "img/uniswap_logo.7846a9ee.svg";